import React from 'react';
import Cookies from 'js-cookie';
import { Subscription } from 'rxjs';
import Layout from 'components/Layout';
import { AppContext } from '../context/AppContext';
import { getGDPRStatus } from '../helpers/geolocation';
import { isLoggedIn, logOut } from '../helpers/login';
import { Segment } from '../analytics';
import { PageNotFoundTemplateProps } from './PageNotFound';
import { PageTemplateProps } from './Page';

type WithLayoutStateType = {
    isLoggedIn: boolean;
    hasGivenCookieConsent: boolean;
};

const textToBooleanMapping: { [index: string]: boolean } = {
    yes: true,
    no: false,
};

const withLayout = (Content: any) => {
    return class extends React.Component<
        PageTemplateProps & PageNotFoundTemplateProps,
        WithLayoutStateType
    > {
        geolocation$: Subscription;

        segment: Segment;
        state = {
            hasGivenCookieConsent: true, // Setting this to true by default so there is no flash
            // of the cookie consent banner when the API request that checks for geolocation
            // is being done
            isLoggedIn: false,
        };

        constructor(props: PageTemplateProps & PageNotFoundTemplateProps) {
            super(props);
            this.segment = this.segment || new Segment();
            this.segment.load();
        }

        componentDidMount() {
            this.geolocation$ = getGDPRStatus().subscribe((GDPRStatus: boolean) => {
                // If the user is part of the GDPR, then show the cookie consent banner
                // if they haven't already accepted the terms
                if (GDPRStatus === true && Cookies.get('cookieconsent_status') !== 'dismiss') {
                    this.setState({ hasGivenCookieConsent: false });
                }
            });

            isLoggedIn(this.segment).then((userIsLoggedIn: boolean) => {
                this.setState({ isLoggedIn: userIsLoggedIn });
            });

            this.segment.page(this.props.data.prismicPage || this.props.data.prismic404Page);
        }
        componentWillUnmount() {
            this.geolocation$.unsubscribe();
        }

        // Called when a user manually logs out
        logOutFromApp() {
            // TODO: AJAX.post('/tokens/invalidate');
            logOut(this.segment);
            this.setState({
                isLoggedIn: false,
            });
        }

        handleCookieConsent = () => {
            Cookies.set('cookieconsent_status', 'dismiss', {
                path: '/',
                domain: process.env.COOKIE_DOMAIN,
                expires: 365,
            });
            this.setState({ hasGivenCookieConsent: true });
        };

        render() {
            const page = this.props.data.prismicPage || this.props.data.prismic404Page;

            const options = this.props.data.prismicPage
                ? {
                      show_navigation_header:
                          textToBooleanMapping[page.data.show_navigation_header],
                      show_footer: textToBooleanMapping[page.data.show_footer],
                  }
                : {
                      show_navigation_header: true,
                      show_footer: true,
                  };

            return (
                <AppContext.Provider
                    value={{
                        pageContext: this.props.pageContext,
                        isLoggedIn: this.state.isLoggedIn,
                        logOut: () => this.logOutFromApp(), // TODO: add test for appContext provider
                        alternateLanguages: page.alternate_languages,
                        options,
                        homePage: page.data.home_page || null,
                        segment: this.segment,
                    }}
                >
                    <Layout
                        // TODO: remove these props and use app context instead
                        lang={page.lang}
                        alternateLanguages={page.alternate_languages}
                        options={options}
                        homePage={page.data.home_page || null}
                        pageContext={this.props.pageContext}
                        hasGivenCookieConsent={this.state.hasGivenCookieConsent}
                        handleCookieConsent={this.handleCookieConsent}
                    >
                        <Content {...this.props} />
                    </Layout>
                </AppContext.Provider>
            );
        }
    };
};

export default withLayout;
